export default {
  'paymentHistory.time.last_month': '最近一個月',
  'paymentHistory.time.last_three_months': '最近三個月',
  'paymentHistory.time.last_six_months': '最近六個月',
  'paymentHistory.time.last_one_year': '最近一年',
  'paymentHistory.status.completed': '已完成',
  'paymentHistory.status.canceled': '已取消',
  'paymentHistory.status.partial_canceled': '部分取消',
  'paymentHistory.title': '交易記錄',
  'paymentHistory.detail': '交易明細',
  'paymentHistory.update_time': '時間',
  'paymentHistory.total_amount': '總金額',
  'paymentHistory.store': '門市',
  'paymentHistory.status': '狀態',
  'paymentHistory.level_progress_text.amounts':
    '再消費 <span style="font-weight: 600;color: #05B34D;">{amount}</span> 元',
  'paymentHistory.level_progress_text.counts':
    '再消費 <span style="font-weight: 600;color: #05B34D;">{count}</span> 次 <span style="font-weight: 600;color: #05B34D;">{amount}</span> 元以上',
  'paymentHistory.level_progress_text.or': '或',
  'paymentHistory.period_amount': '效期內累計消費',
  'paymentHistory.member_total_amount': '會員總累積消費',
  'paymentHistory.dollar': '元',
  'paymentHistory.zero_dollar': '0 元',
  'paymentHistory.trade_time': '交易時間',
  'paymentHistory.empty': '無資料',
  'paymentHistory.name': '品項',
  'paymentHistory.quantity': '數量',
  'paymentHistory.price': '單價',
  'paymentHistory.amount': '消費金額',
  'paymentHistory.cancel_date': '取消時間',
} as Record<string, string>;
